"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.proccessPusherEvents = exports.generateGridClientId = exports.applyGridTransactions = void 0;
function applyGridTransactions(api, updates) {
    updates.forEach((u) => {
        const transaction = api.applyTransaction(u);
        api.flashCells({
            rowNodes: [...transaction.add, ...transaction.update, ...transaction.remove],
        });
    });
}
exports.applyGridTransactions = applyGridTransactions;
function generateGridClientId(grid) {
    return grid + '-' + (window.crypto.randomUUID());
}
exports.generateGridClientId = generateGridClientId;
const proccessPusherEvents = (user, createGridTransaction, gridApi, editing, queueParam) => {
    return (data, metadata) => {
        console.log(user.id, data.userId);
        console.log(data);
        if (!data) {
            return;
        }
        const newGridUpdateTransaction = createGridTransaction(data, metadata);
        if (!newGridUpdateTransaction) {
            return;
        }
        const { queue, setQueue } = queueParam;
        // prepare transaction
        const updatesToApply = [...queue, newGridUpdateTransaction];
        if (!editing) {
            applyGridTransactions(gridApi, updatesToApply);
            setQueue(() => []);
            return;
        }
        setQueue(updatesToApply);
        applyGridTransactions(gridApi, updatesToApply);
    };
};
exports.proccessPusherEvents = proccessPusherEvents;
